function initSortable() {
  $("[data-sortable]").each(function() {
    if ($(this).data("ui-sortable")) return;
    $(this).sortable({
      axis: "y",
      handle: ".sortable-handle",
      stop: function(event, ui) {
        masterId = $(this).data("sortable-id");
        sortableIds = $.map($("[data-sortable-id][data-sortable-master='" + masterId + "']"), function(element){ return $(element).data("sortable-id") });
        url = $(this).data("sortable-url");
        $.ajax({
          type: "PATCH",
          url: url,
          dataType: "json",
          data: {ids: sortableIds},
          success: function(result) {
            toastr["success"]("Order Updated");
          },
          error: function(result) {
            toastr["error"]("Order Update Failed");
          }
        })
      }
    });
  });
}

$( document ).on("turbo:load", initSortable);
$( document ).on("turbo:before-stream-render", function() {
  requestAnimationFrame(function() { requestAnimationFrame(initSortable); });
});
